var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style table-style--default"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('div', {
      key: item.title,
      staticClass: "table-style__row"
    }, [_c('div', {
      staticClass: "table-style__th"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('div', {
      staticClass: "table-style__td"
    }, [_vm._v(" " + _vm._s(item.value) + " ")])])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }